<style scoped>
    @import url("../../../styles/smartControl/formExtIrrig.scss");
</style>

<template>
    <div class="box_formExtIrrig">

        <v-btn 
        @click="back2cycles()"
        class="mt-1 mb-1" 
        :style="{'width':'90px','font-size':'0.8rem'}">
            <v-icon>mdi-arrow-up</v-icon>
            <span>voltar</span>
        </v-btn>

        <div class="mainTit mb-2">
            <span>{{ msgTit }}</span>
        </div>

        <div class="linhaForm">
            <v-radio-group 
            class="ml-2 elSelect"
            :style="{'height':'40px'}"
            v-model="formLocal.status" inline
            >
                <v-radio label="ON" value="on"></v-radio>
                <v-radio label="OFF" value="off"></v-radio>
            </v-radio-group>
        </div>

        <div class="menuForm" v-if="formLocal.status == 'on'">

            <!---<div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Origem da irrigação:</span>
                <span class="ml-2 elInput" :style="{'justify-content': 'flex-end'}">Externa</span>
            </div>--->

            <div class="linhaForm">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="deviceSelected"
                    :items="liDevicesExib"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarDevice(deviceSelected)"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Título Atuador/setor:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="atuadorSelected"
                    :items="liSelectAtuador"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarAtuador(atuadorSelected)"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Tipo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="tipoSelected"
                    :items="liSelectTipo"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarTipo(tipoSelected)"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm" v-if="tipoSelected == 'Temporizado'">
                <span class="tLinha">Tempo:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.act_sec"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        :placeholder="formLocal.act_sec"
                        @change="timeout_fmt_check('act_sec')"
                    />
                </div>
            </div>
            <div class="linhaForm" v-else>
                <span class="tLinha">Atuação:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="formLocal.act_direct"
                    :items="liSelectComando"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    ></v-autocomplete>
                </div>
            </div>

            <!-- OPCIONAL -->
            <div class="linhaForm" v-if="tipoSelected != 'Temporizado'">
                <span class="tLinha">Contra resposta:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="flagStrReturnDirectCommand"
                    :items="liReturnDirectCommand"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    ></v-autocomplete>
                </div>
            </div>

            <!-- OPCIONAL -->
            <div class="linhaForm" v-if="flagStrReturnDirectCommand == 'Com retorno' && tipoSelected != 'Temporizado'">
                <span class="tLinha">Tempo de contra resposta:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.direct_sec_string"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        @change="timeout_fmt_check('direct_sec_string')"
                    />
                </div>
            </div>

            <!-- OPCIONAL -->
            <div class="linhaForm" v-if="tipoSelected != 'Temporizado'">
                <span class="tLinha">Valor da ação:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.act_value"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                    />
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Porta:</span>
                <v-chip class="ml-2" color="#397E9E">{{ formLocal.pino_atuador }}</v-chip>
            </div>

        </div>

        <!-- SENSORES E INDICES CALC -->
        <div class="mainTit mt-2 mb-2" v-if="formLocal.status == 'on' && doc2edit.srcStr == 'li_crossings'">
            <span>Condicionante de disparo</span>
        </div>

        <div class="menuForm" v-if="formLocal.status == 'on' && doc2edit.srcStr == 'li_crossings'">

            <div class="linhaForm">
                <span class="tLinha">Tipo de rompimento:</span>
                <v-radio-group 
                class="ml-2 elSelect"
                :style="{'height':'40px'}"
                v-model="formLocal.threshold_type" inline
                >
                    <v-radio label="Superior" value="sup"></v-radio>
                    <v-radio label="Inferior" value="inf"></v-radio>
                </v-radio-group>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Valor do rompimento:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.threshold_value"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                    />
                </div><!-- :placeholder="formLocal.threshold_value" -->
            </div>

            <div class="linhaForm">
                <span class="tLinha">Tempo de efeito:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.seconds_to_effect"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        @change="timeout_fmt_check('seconds_to_effect')"
                    />
                    <!-- :placeholder="formLocal.seconds_to_effect" -->
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="formLocal.device_name"
                    :items="liDevicesRompExibNames"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarDeviceRomp"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Parâmetro:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="formLocal.title_param"
                    :items="liParamsSelected2exib"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarParamRomp"
                    ></v-autocomplete>
                </div>
            </div>

        </div>

        <!--<v-btn @click="addExt()" v-if="!flagMsgErro"
        class="mt-2 mb-2"
        block 
        :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
        >adicionar</v-btn>-->

        <div v-if="flagMsgErro" class="mt-1 mb-2" :style="{'align-self':'center','color':'white','font-size':'0.8rem','font-weight':'100'}">{{ msgErro }}</div>
    </div>
</template>

<script>
export default {

    props:['agent_unit','doc2edit'],

    data() {
        return {

            // -- default form
            form_snapshot:{}, // recebe e copia o doc inicial
            formLocal: {
                'status':'off',
                'controlador':'',
                'actuator_name':'', // actuator_name
                'device_id':'',
                'act_type':'', // Direto ou Temporizado (formato local)
                'pino_atuador':'', // APENAS LOCAL (view)
                'act_direct':'',
                'act_sec':'',
                'sys_ctrl':'',
                'direct_sec':'',
                'direct_sec_string':'', // key criada localmente para manuseio form
            },
            flagChanged:false,
            flagSnapActive:false, // false enquanto esta inicializando o doc antes do snapshot

            // -- handle atuadores.
            liDevices: [],
            liDevicesExib: [],
            liDevicesCollSRC:[], // coll_ctrl sinc com index list
            deviceSelected: '',
            atuadorSelected: '',
            liSelectAtuador: [],
            liGeralDispositivo:[], // aux para seleção de atuadores --> keys específicas de atuadores do controlador ja selecionado

            // tipo
            tipoSelected:'',
            liSelectTipo:['Direto','Temporizado'],

            // comando direto
            liSelectComando:['Ligar','Desligar'],

            // comando de retorno a um comando direto (opcional)
            flagStrReturnDirectCommand:'Sem retorno',
            liReturnDirectCommand:['Com retorno', 'Sem retorno'],

            // sensores e indices
            liDevicesRompExibNames:[], // contem todas opções de elem limiares
            liDevicesRompParams:[], // contem todas opções de elem limiares
            liParamsSelected2exib:[], // contem os elem associados ao device selecionado

            // controle de título do card local
            msgTit:'',

            // controle de erro local
            flagMsgErro:false,
            msgErro:'Preencha corretamente todos os campos.',
        }
    },

    watch: {
        formLocal: {
            deep: true,
            handler() {
                this.watchChange(); // call func in local methods
            }
        }
    },

    methods:{

        back2cycles() { this.$emit('flagBoolCloseFormAgend',false) },

        trocarParamRomp(targetParamName) {
            //console.log('targetParamName: ',targetParamName)

            // se precisar o param possui localmente o device_id do sensor
            
            for (let c = 0; c < this.liDevicesRompParams.length; c++) {
                //if (this.liDevicesRompParams[c].titulo == targetParamName) {
                //    this.formLocal.target_key = this.liDevicesRompParams[c].sub_marcador // update local
                //}
                const param = this.liDevicesRompParams[c]
                if (
                    param.titulo === targetParamName &&
                    param.device_id === this.formLocal.device_id
                ) {
                    this.formLocal.target_key = param.sub_marcador // update local
                }
            }
            //console.log('this.formLocal.target_key: ',this.formLocal.target_key)
        },

        trocarDeviceRomp(targetDeviceName) {
            let liParamsSelectedByDevice = []
            for (let c = 0; c < this.liDevicesRompParams.length; c++) {
                
                if (this.liDevicesRompParams[c].device_name == targetDeviceName) {

                    this.formLocal.device_id = this.liDevicesRompParams[c].device_id // update local (titulo seleciona o device_id)
                    liParamsSelectedByDevice.push(this.liDevicesRompParams[c].titulo)

                    // -- reset
                    this.formLocal.target_key = '' // ---> validar key nao vazia na func final (!)
                    this.formLocal.title_param = '' // ""
                }
            }
            this.liParamsSelected2exib = liParamsSelectedByDevice
        },

        trocarDevice(deviceSelected) {

            let c=0
            while (c < this.liDevices.length) {
                
                if (this.liDevices[c]['nome_device'] == deviceSelected) {

                    this.formLocal['device_id'] = this.liDevices[c]['device']
                    this.formLocal['controlador'] = deviceSelected
                    this.formLocal['sys_ctrl'] = this.liDevicesCollSRC[c] // string list
                    
                    this.liGeralDispositivo = this.liDevices[c]['liAtuadores'] // init this.liGeralDispositivo
                    let j=0
                    while (j < this.liGeralDispositivo.length) {
                        this.liSelectAtuador.push(this.liGeralDispositivo[j]['titulo']) // recortar tit
                        j++
                    }
                    c=this.liDevices.length // break
                }
                c++
            }
        },

        trocarAtuador(atuadorSelected) {
            //console.log('atuadorSelected: ',atuadorSelected)
            this.formLocal['actuator_name'] = atuadorSelected
            //console.log('+---- (1) ----+')

            // -- obter a porta do atuador.
            let c=0;
            while (c < this.liGeralDispositivo.length) {
                //console.log('+---- (2) ----+')
                if (this.liGeralDispositivo[c]['titulo'] == atuadorSelected) {
                    //console.log('+---- (3) ----+')
                    this.formLocal.pino_atuador = this.liGeralDispositivo[c]['porta']
                    //console.log('+---- (4) ----+')
                    //this.formLocal.sys_agend = this.liGeralDispositivo[c]['sys_agend']
                    //console.log('+---- (5) ----+')
                    return
                }
                c++
            }
        },

        trocarTipo(tipoSelected) {
            this.formLocal['act_type'] = tipoSelected

            // -- condicionamento do tipo.

            if (tipoSelected == 'Temporizado') {
                
                if (this.formLocal.act_sec == '') { // senao for vazio
                    const segundos_exib = this.segundosParaHHMMSS(1) // int -> string
                    this.formLocal.act_sec = segundos_exib // string
                }
                else {
                    this.formLocal['act_direct'] = ''
                    this.formLocal['act_sec'] = '00:00:01'
                }
            }
            
            if (tipoSelected == 'Direto') {

                if (!this.formLocal.act_direct || this.formLocal.act_direct.trim() === '') {
                    this.formLocal['act_direct'] = 'Desligar'
                    this.formLocal['act_sec'] = ''
                }
            }
        },

        HHMMSStoSegundos(hhmmss) {
            // Quebra a string "HH:MM:SS" em partes
            const [h, m, s] = hhmmss.split(":").map(Number);
            // Converte para inteiro em segundos
            return (h * 3600) + (m * 60) + s;
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;
            //console.log('[segundosParaHHMMSS] segundos: ',segundos)

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },

        timeout_fmt_check(flagStr) { 

            let s = null
            if (flagStr == 'act_sec') { s = (this.formLocal.act_sec || '').trim(); }
            if (flagStr == 'direct_sec_string') { s = (this.formLocal.direct_sec_string || '').trim(); }
            if (flagStr == 'seconds_to_effect') { s = (this.formLocal.seconds_to_effect || '').trim(); }
            
            // sanear para HH:MM:SS se quiser (regex/parse)
            if (!/^\d{2}:\d{2}:\d{2}$/.test(s)) {

                if (flagStr == 'act_sec') {
                    this.formLocal.act_sec = "00:00:01"
                }

                if (flagStr == 'direct_sec_string') {
                    this.formLocal.direct_sec_string = "00:00:01"
                }

                if (flagStr == 'seconds_to_effect') {
                    this.formLocal.seconds_to_effect = "00:00:01"
                }

                this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                this.colorMsg = '#ec5858' // vermelho suave
                this.flagMsgForm = true
            }
            else {
                this.msgForm = ''
                this.colorMsg = ''
                this.flagMsgForm = false
            }
        },

        normalizeForm(obj) {
            const out = JSON.parse(JSON.stringify(obj))
            // -- garantir que timeout_tempo_hr SEMPRE seja "HH:MM:SS"
            if (out?.act_sec != null) {
                // se vier número, converte para string
                if (typeof out.act_sec === 'number') {
                out.act_sec = this.segundosParaHHMMSS(out.act_sec)
                }
            }
            return out
        },

        initListRomp() {
            // lista de sensores e indices calculados formatados ao frontend.
            const liSensores = Array.isArray(this.agent_unit?.sensores)
                ? this.agent_unit.sensores
                : [];

            const liIndices = Array.isArray(this.agent_unit?.indices)
                ? this.agent_unit.indices
                : [];

            let liDevicesRomp = liSensores.concat(liIndices);
            //console.log('tam liDevicesRomp:', liDevicesRomp.length);
            
            let liDevicesRompExibNames = [] // lista de strings para o select
            let liDevicesRompParams = []
            for (let m = 0; m < liDevicesRomp.length; m++) {
                const device = liDevicesRomp[m];
                const params = Array.isArray(device?.params)
                    ? device.params
                    : [];
                if (params.length > 0) {

                    liDevicesRompExibNames.push(device.nome)

                    for (let n = 0; n < params.length; n++) {

                        let param = structuredClone(params[n]);

                        param.device_id = device.device // criando nova key | id do controlador
                        param.device_name = device.nome // criando nova key | nome do controlador
                        liDevicesRompParams.push(param)
                    }
                }
            }
            //console.log('tam liDevicesRompExibNames:', liDevicesRompExibNames.length);
            //console.log('tam liDevicesRompParams:', liDevicesRompParams.length);
            this.liDevicesRompExibNames = liDevicesRompExibNames
            this.liDevicesRompParams = liDevicesRompParams

            return liDevicesRomp // usado para inicializar a exibição de um "rompedor" já existente
        },

        initOptionsForm() {
            this.liDevices = []
            this.liDevicesExib = []
            this.liDevicesCollSRC = []

            let liAtuadores = this.agent_unit['atuadores'] // lista de controladores contendo atuadores (pinos)
            let c=0
            while ( c < liAtuadores.length ) {

                let params = liAtuadores[c]['params']
                let liAtu = [] // reset
                let j=0
                while (j < params.length) {

                    if (params[j]['sub_marcador'] == 'irrig') { 

                        liAtu.push({
                            'titulo':params[j]['titulo'],
                            'atuante':params[j]['sub_marcador'],
                            'porta': params[j]['pino'],
                            //'sys_ctrl': params[j]['sistema']
                        })
                    }
                    j++
                }
                this.liDevices.push({
                    'nome_device':liAtuadores[c]['nome'], 
                    'device':liAtuadores[c]['device'], 
                    'liAtuadores':liAtu
                })
                this.liDevicesExib.push(liAtuadores[c]['nome'])
                this.liDevicesCollSRC.push(liAtuadores[c]['coll_name_src']) // sys_ctrl
                c++
            }

            this.initListRomp()
        },

        initFormRcv(index) {

            this.formLocal = structuredClone(this.doc2edit.doc)
            //console.log('this.formLocal: ',this.formLocal)

            //console.log('this.doc2edit.srcStr: ',this.doc2edit.srcStr)
            if (this.doc2edit.srcStr == 'li_transition_entry') {
                this.msgTit = `Elemento ${index+1} em edição | Atuação de transição`
            }
            if (this.doc2edit.srcStr == 'li_action_on_cycle_start') {
                this.msgTit = `Elemento ${index+1} em edição | Atuação de entrada`
            }
            if (this.doc2edit.srcStr == 'li_crossings') {
                this.msgTit = `Elemento ${index+1} em edição | Atuação em operação`

                const seconds_to_effect_raw = this.formLocal['seconds_to_effect'] // int
                //console.log('seconds_to_effect_raw: ',seconds_to_effect_raw)
                const seconds_to_effect = this.segundosParaHHMMSS(seconds_to_effect_raw) // int -> string
                //console.log('seconds_to_effect: ',seconds_to_effect)
                this.formLocal.seconds_to_effect = seconds_to_effect // string
            }

            // -- formatar tipo de disparo para o view.
            if (this.formLocal['act_type'] == 'direct') {

                this.tipoSelected = 'Direto'

                if (this.formLocal['act_direct'] == 'turn_on') { 
                    this.formLocal['act_direct'] = 'Ligar' 
                }
                else { this.formLocal['act_direct'] = 'Desligar' }
            }
            else {
                this.tipoSelected = 'Temporizado'
                const seconds_src = this.formLocal['act_sec'] // int
                const segundos_exib = this.segundosParaHHMMSS(seconds_src) // int -> string
                this.formLocal.act_sec = segundos_exib // string
            }

            // CONTRA RESPOSTA a um comando direto.
            if (this.formLocal['direct_sec'] != '') {
                this.flagStrReturnDirectCommand = 'Com retorno'
                const secondsSrcReturn = this.formLocal['direct_sec'] // int
                const segundosUntilReturn = this.segundosParaHHMMSS(secondsSrcReturn) // int -> string
                this.formLocal['direct_sec_string'] = segundosUntilReturn
            } else {
                this.flagStrReturnDirectCommand = 'Sem retorno'
                //this.formLocal['direct_sec'] = '' // mantém string vazia | mantém o que já há nela sem alterar inicialmente
                this.formLocal['direct_sec_string'] = this.segundosParaHHMMSS(1) // int -> string
            }

            // -- obter nome do controlador e o pino de atuação.
            let liControllers = this.agent_unit['atuadores']
            for (let i = 0; i < liControllers.length; i++) {
                //console.log('[FormAct] liControllers[i][coll_name_src]: ',liControllers[i]['coll_name_src'])
                //console.log('[FormAct] this.formLocal[sys_ctrl]: ',this.formLocal['sys_ctrl'])
                if (liControllers[i]['coll_name_src'] == this.formLocal['sys_ctrl']) {
                    //console.log('[FormAct] +------- x1 -------+')
                    this.formLocal['controlador'] = liControllers[i]['nome']
                    this.deviceSelected = this.formLocal['controlador']
                    let liActuators = liControllers[i]['params'] // list
                    //console.log('[FormAct] +------- x2 -------+')
                    for (let j = 0; j < liActuators.length; j++) {
                        //console.log('[FormAct] liActuators[j][titulo]: ',liActuators[j]['titulo'])
                        //console.log('[FormAct] this.formLocal[actuator_name]: ',this.formLocal['actuator_name'])
                        if (liActuators[j]['titulo'] == this.formLocal['actuator_name']) {
                            //console.log('[FormAct] +------- x3 -------+')
                            this.formLocal['pino_atuador'] = liActuators[j]['pino'] // ex.: '02'
                            //break <-- ler todos os atuadores para formar a lista select abaixo
                        }

                        this.liSelectAtuador.push(liActuators[j]['titulo'])

                        // -- sinc list func trocarAtuador()
                        this.liGeralDispositivo.push({
                            'titulo':liActuators[j]['titulo'],
                            'atuante':liActuators[j]['sub_marcador'],
                            'porta': liActuators[j]['pino'],
                            //'sys_ctrl': liActuators[j]['sistema']
                        })
                    }
                    break
                }
            }

            this.atuadorSelected = this.formLocal['actuator_name']

            const liDevicesRomp = this.initListRomp() // -- montar exibição de seleção de threshold

            // -- inicializar nome do dispositivo controlador de antes da edição.
            for (let x = 0; x < liDevicesRomp.length; x++) {
                if (liDevicesRomp[x].device == this.formLocal.device_id) {
                    this.formLocal.device_name = liDevicesRomp[x].nome // nome/titulo do controlador
                    const liParams = liDevicesRomp[x].params
                    // -- montar lista de params do device ja selecionado.
                    for (let y = 0; y < liParams.length; y++) {
                        this.liParamsSelected2exib.push(liParams[y].titulo)
                    }
                }
            }

            this.form_snapshot = structuredClone(this.formLocal); // depth copy
            this.formLocal = structuredClone(this.form_snapshot); // depth copy
            this.flagSnapActive = true
        },

        watchChange() { 
            if (!this.flagSnapActive) { return; }

            this.flagChanged = JSON.stringify(this.formLocal) !== JSON.stringify(this.form_snapshot); 

            if (!this.flagChanged) { return; }

            //console.log('(1) formLocal: ',this.formLocal)

            let formFinal = structuredClone(this.formLocal)

            // -- validação de doc geral.

            if (!["on", "off"].includes(formFinal.status)) { return; }

            delete formFinal.controlador; // rmv key controlador

            //console.log('(antes) formFinal.act_type: ',formFinal.act_type)
            if (formFinal.act_type == 'Direto') {
                //formFinal.act_type = 'direct';
                if (formFinal.act_direct == 'Ligar') { formFinal.act_direct = 'turn_on'; }
                else { formFinal.act_direct = 'turn_off'; }
                formFinal.act_type = 'direct'
                formFinal.act_sec = '';
            }
            else { // -- <this.formLocal.act_type == 'timeout'>
                // ---- conv minutos 00:00:30 para segundos inteiro 30
                formFinal.act_sec = this.HHMMSStoSegundos(formFinal.act_sec);
                formFinal.act_type = 'timeout';
                formFinal.act_direct = '';
            }
            //console.log('(depois) formFinal.act_type: ',formFinal.act_type)
            //console.log('(depois) formFinal.act_direct: ',formFinal.act_direct)
            //console.log('(depois) formFinal.act_sec: ',formFinal.act_sec)

            // CONTRA RESPOSTA a um comando direto.
            if (
                formFinal.act_type === 'direct' &&
                this.flagStrReturnDirectCommand === 'Com retorno' 
            ) {
                formFinal.direct_sec = this.HHMMSStoSegundos(formFinal.direct_sec_string);
            }
            else { // else redundante (pois só há contra resposta se for comando direct e nao timeout)
                formFinal.direct_sec = ''; // limpeza explícita
            }

            // -- validação parte doc crossing.
            if (this.doc2edit.srcStr == 'li_crossings') {
                // ---- minutos 00:19:00 para segundos inteiro 1140
                formFinal.seconds_to_effect = this.HHMMSStoSegundos(formFinal.seconds_to_effect);
                delete formFinal.device_name; // rmv key device_name (apenas em crossing)
            }

            //if (this.flagChanged) { console.log('(2) formLocal: ',formFinal) }

            //this.$emit('flagBoolChangeDoc', this.flagChanged) // emitir ao pai que houve edição
            
            // --> emitir doc editado ao pai
            const dictInfoDoc = {
                'indexListAct':this.doc2edit.index,
                'srcStr':this.doc2edit.srcStr,
                'formFinal':formFinal,
            }
            this.$emit('infoDocEdited', dictInfoDoc)

            // --> ao alterar o filho (doc), este é sobreposto no doc de origem em FaseExib.vue
        },
    },

    created() {
        //window.scrollTo(0,0)

        // -- inicialização padrão.
        this.initOptionsForm()

        // -- edição.
        if (this.doc2edit.index != -1) { 
            this.initFormRcv(this.doc2edit.index) 
        }
    }
}
</script>
